<div class="pwdupdate-page">
  <div class="pwdupdate-desc">{{'common.secure_update_pwd_expiration_msg' | cxTranslate}}</div>
  <div class="pwdupdate-container pt-3">
    <p class="my-5 mx-3 text-align-left">{{'common.secure_update_application_msg' | cxTranslate}}</p>
    <div class="pwdupdate-form-block">
      <form [formGroup]="pwdchangeForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
        <div class="">
          <div class="form-group">
            <label for="password">{{'common.updatePwd_pwd' | cxTranslate}}</label>
            <input type="password" formControlName="password" class="form-control" name="password"
              [ngClass]="{ 'is-valid': (pwdform.password.dirty || submitted) && passwordValid, 'is-invalid': (pwdform.password.dirty || submitted || pwdform.password.touched) && !passwordValid }" />
              @if ((requiredValid ||pwdform.password.touched ) && !passwordValid) {
                <span class="text-danger"
                  >{{'common.secure_update_pwd_doesnot_meetReq_msg'
                | cxTranslate}}</span>
              }
              @if (requiredValid  && !passwordValid) {
                <div class=" error-box">
                  @if (requiredValid) {
                    <div id="validation-rules">
                      <div [ngClass]="{ 'text-success': minLengthValid, 'text-danger': !minLengthValid }">
                        <img [attr.src]="minLengthValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                          alt="" class="icon-right">
                          {{'common.secure_update_pwd_validation_msg1' | cxTranslate}}
                        </div>
                        <div
                          [ngClass]="{ 'text-success': requiresLowercaseValid, 'text-danger': !requiresLowercaseValid }">
                          <img [attr.src]="requiresLowercaseValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                            class="icon-right">
                            {{'common.secure_update_pwd_validation_msg2' | cxTranslate}}
                          </div>
                          <div
                            [ngClass]="{ 'text-success': requiresUppercaseValid, 'text-danger': !requiresUppercaseValid }">
                            <img [attr.src]="requiresUppercaseValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                              class="icon-right">
                              {{'common.secure_update_pwd_validation_msg3' | cxTranslate}}
                            </div>
                            <div
                              [ngClass]="{ 'text-success': requiresDigitValid, 'text-danger': !requiresDigitValid }">
                              <img [attr.src]="requiresDigitValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                class="icon-right">
                                {{'common.secure_update_pwd_validation_msg4' | cxTranslate}}
                              </div>
                              <div
                                [ngClass]="{ 'text-success': requiresSpecialCharsValid, 'text-danger': !requiresSpecialCharsValid }">
                                <img [attr.src]="requiresSpecialCharsValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                  class="icon-right">
                                  {{'common.secure_update_pwd_validation_msg5' | cxTranslate}}
                                </div>
                                <div>
                                  {{'common.secure_update_recentused_pwdMsg' | cxTranslate}}
                                </div>
                                <div>
                                  {{'common.secure_update_pwd_personalInfo_msg' | cxTranslate}}
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <div class="form-group">
                        <label for="confirmPassword">{{'common.updatePwd_checkPwd' | cxTranslate}}</label>
                        <input type="password" formControlName="confirmPassword" class="form-control"
                          name="confirmPassword"
                          [ngClass]="{ 'is-valid': (submitted || pwdform.confirmPassword.dirty) && !pwdform.confirmPassword.errors, 'is-invalid': (submitted || pwdform.confirmPassword.dirty  || pwdform.confirmPassword.touched ) && pwdform.confirmPassword.errors }">
                          @if ((submitted || pwdform.confirmPassword.dirty ) && pwdform.confirmPassword.errors) {
                            <div class="invalid-feedback"
                              >
                              @if (pwdform['confirmPassword'].errors['required']) {
                                <div>
                                  {{'common.updatePwd_checkPwd_invalid' |
                                  cxTranslate}}
                                </div>
                              }
                              @if (pwdform['confirmPassword'].errors['mismatch']) {
                                <div>
                                  {{'common.validation_checkPwd_equals' |
                                cxTranslate}}</div>
                              }
                            </div>
                          }
                        </div>
                      </div>

                      <div class="form-group">
                        <button type="submit" class="btn btn-block btn-primary update-btn "
                          [disabled]="pwdchangeForm.invalid">
                          {{'common.updatePwd_submit'|cxTranslate}}
                          <img src="/icons/link-white.svg" class="icon-right" alt="">
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>